import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation, Switch, Route, Redirect } from 'react-router-dom';
import ViewAds from './ViewAds';
import PhotoEditor from './PhotoEditor';

const AdBuilderContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: #eee;
`;

const Container = styled.div`
    display: flex;
    height: 100%;
`;

const ConnectedAdBuilder = () => {
    const [adData, setAdData] = useState({ adHeight: null, adWidth: null, startingPoint: '' });

    const [adPostData, setAdPostData] = useState({
        data: null,
        error: null,
        isLoading: false,
    });

    const [pageIndex, setPageIndex] = useState(0);

    const handleNavButtonNext = () => {
        setPageIndex(pageIndex + 1);
    };
    const handleNavButtonBack = () => {
        setPageIndex(pageIndex - 1);
    };

    const saveNewAd = () => {
        setPageIndex(0);
    };

    return (
        <AdBuilderContainer>
            <Switch>
                <Route path="/portal/adBuilder/buildAnAd">
                    <PhotoEditor />
                </Route>
                <Route path="/portal/adBuilder/viewAds">
                    <ViewAds />
                </Route>
            </Switch>
        </AdBuilderContainer>
        // </Container>
    );
};

export default ConnectedAdBuilder;
